import { Injectable, Inject } from '@angular/core';
import { BaseService } from './base.service';
import { BehaviorSubject } from 'rxjs';
import { WINDOW } from '../http/window.providers';

import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LanguageService extends BaseService {
    /**
     * availableLanguages()
     */
    availableLangs: BehaviorSubject<any> = new BehaviorSubject(null);

    /**
     * selectedLanguage
     */
    selectedLanguage: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(@Inject(WINDOW) private window: Window, private translateService: TranslateService) {
        super();
    }

    setupLanguages(selectedLanguage: string, languages: string[]) {
        const defaultLanguage = selectedLanguage || languages.find((lang) => lang === 'pt-BR');

        const defaultAvailableLanguages = languages.filter((lang) => lang !== defaultLanguage);

        /* Verifica se já existem preferencias do usuário salvas */
        const localUserLangs = this.localStorage.getUserLangs();

        let selected = localUserLangs?.selected || defaultLanguage,
            available = localUserLangs?.available || defaultAvailableLanguages;

        this.selectedLanguage.next(selected);

        this.translateService.use(selected);

        const availableLangs = available.filter((lang) => lang !== selected);
        this.availableLangs.next(availableLangs);

        if (!localUserLangs) {
            this.saveLanguagesLocally();
        }
    }

    changeLanguage(previous, selected, reload = false) {
        const availableLangs = this.availableLangs.getValue();
        // prettier-ignore
        const newAvailableLangs = availableLangs.filter((lang) => lang !== selected);
        newAvailableLangs.push(previous);
        this.availableLangs.next(newAvailableLangs);
        this.selectedLanguage.next(selected);
        this.changeWidgetLanguage(selected);

        this.localStorage.saveUserLangs(selected, newAvailableLangs);
        if (reload) {
            this.window.location.reload();
        }
    }

    saveLanguagesLocally() {
        this.localStorage.saveUserLangs(this.selectedLanguage.getValue(), this.availableLangs.getValue());
    }

    public changeWidgetLanguage(language: string) {
        let languageStrWidget;
        if (language.includes('es')) {
            languageStrWidget = 'es';
        } else if (language.includes('en')) {
            languageStrWidget = 'en';
        } else {
            languageStrWidget = language;
        }

        (this.window as any).UserWay?.changeWidgetLanguage(languageStrWidget);
    }
}
